module.exports = __webpack_public_path__ + "static/img/18.f6193aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/18.png
// module id = wpee
// module chunks = 1